import { Translation } from '@ps/web-shared-components';
import React, { useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';

import { Context as NavigationContext } from '@swf/components/StarsWizard/components/Navigation/Navigation';
import useWizardExit from '@swf/core/hooks/useWizardExit';
import { select } from '@swf/core/store';

import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';
import Username from '../../../Username/Username';

import {
  TXTMOB_Create_User_ID,
  TXTWCL_LetXs_create_your_Username,
  TXTWCL_This_is_the_name_youXll_use_wh_ELL_1
} from './SignupUsername.messages.json';

const SignupUsername: React.FunctionComponent = () => {
  const { goPrevious } = useContext(NavigationContext);
  const exitWizard = useWizardExit();
  const isSiteUS = useSelector(select.cms.isSiteUS);

  const goBack = useCallback(
    () => (isSiteUS ? exitWizard() : goPrevious()),
    [exitWizard, goPrevious, isSiteUS]
  );

  return (
    <Container
      page={SignupUsername}
      headerProps={{
        title: <Translation {...TXTMOB_Create_User_ID} />,
        buttons: { back: true, onBackClick: goBack }
      }}
      pageTopTitle={<Translation {...TXTWCL_LetXs_create_your_Username} />}
      pageTopSubtitle={<Translation {...TXTWCL_This_is_the_name_youXll_use_wh_ELL_1} />}
    >
      <fieldset>
        <Username />
      </fieldset>
      <CTAButton />
    </Container>
  );
};

SignupUsername.displayName = 'SignupUsername';

export default SignupUsername;
